module Meevo.Components.Controls {

    import IStorageFile = Meevo.Model.IStorageFile;

    class MeevoImageComponent implements ng.IComponentController {
        storageFile: IStorageFile;
        height: number;

        get src() {
            return this.file ? this.file.fileUrl : '';
        }

        get file() {
            if (!this.storageFile) return null;
            if (!this.storageFile.meevoFile) return null;

            if (this.storageFile.meevoFile.files.length === 0) return null;

            return this.storageFile.meevoFile.files[0];
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoImage', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/meevoImage/meevo-image.component.html',
            controller: MeevoImageComponent,
            controllerAs: '$ctrl',
            bindings: {
                storageFile: '=',
                height: '<'
            }
        });
}
